import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
// slices
import calendarReducer from './slices/calendar';
import apiMessage from './slices/apiMessage';

import { apiSlice } from './rtkQuery/apiSlice';

// ----------------------------------------------------------------------

export const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: []
};

const rootReducer = combineReducers({
  calendar: calendarReducer,
  apiMessage: apiMessage,
  [apiSlice.reducerPath]: apiSlice.reducer
});

export default rootReducer;
